import React from 'react';
import translate from '../services/translation.json';
import './../assets/scss/partners.scss';
import caqLogo from '../assets/images/CAQ-light.svg';

const Partners = ({lang}) => {
  return (
    <div className="partners page-container">
      <h1 className="blue center title">{translate[lang].partners.title}</h1>
      <div className="partners-wrapper padded-container">
        <div className="partner-card">
          <div className="partner-title">
            <h2 className="partner-name">{translate[lang].partners.caq.title}</h2>
            <div className="partner-logo-container">
              <img src={caqLogo} alt="CAQ Logo" className="partner-logo" />
            </div>
          </div>
          <p className="partner-description pre-wrap">{translate[lang].partners.caq.desc}</p>
          <a href={translate[lang].partners.caq.link} target='_blank' rel="noopener noreferrer" className="partner-link">
            {translate[lang].partners.caq.link_text}
          </a>
        </div>
      </div>
    </div>
  );
};

export default Partners;